import { Link, generatePath } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { routes } from '~/routes';
import { CONFIRM_CANDIDATE_LABEL } from '~/utils/Enum';

/** Clickable div with a title on the top and a big number below */
const NumberItemWithTitle = ({ title, value, clickUrl, highlightCount, listener }) => {
  const highlighted = highlightCount && value > 0;
  
  const titleSlug = title.toLowerCase().replace(/\s+/g, '-');
  const buttonDataCy = `${titleSlug}-button`;
  const countDataCy = `${titleSlug}-count`;

  return (
    <div onClick={() => listener?.()}>
      <Link
        data-cy={buttonDataCy}
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          fontFamily: 'Nunito',
          justifyContent: 'space-evenly',
          textDecoration: 'none',
          gap: 8,
        }}
        to={clickUrl}
      >
        <div
          data-cy={countDataCy}
          style={{
            alignItems: 'center',
            backgroundColor: highlighted ? colors.error[500] : colors.secondary[500],
            borderRadius: '20px',
            boxShadow: '0 8px 12px 2px #00000026, 0 2px 4px 0px #00000026',
            color: highlighted ? colors.shades[0] : colors.neutral[50],
            display: 'flex',
            fontSize: '46px',
            fontWeight: 700,
            height: '95px',
            justifyContent: 'center',
            lineHeight: '62px',
            width: '97px',
          }}
        >
          {value}
        </div>
        <Typography as="span">{title}</Typography>
      </Link>
    </div>
  );
};

const ShiftsWidget = ({ activeCount, scheduledCount, actionRequiredCount, isLoading }) => {
  return (
    <Link
      style={{
        fontFamily: 'Nunito',
        textDecoration: 'none',
        flex: 1,
      }}
      to={generatePath(routes.shiftsOverview, { type: 'open' })}
    >
      <div className="dashboard-shifts-shadow" data-cy="shifts-overview-section">
        {(!activeCount && !scheduledCount && !actionRequiredCount) || isLoading ? (
          <div
            style={{
              height: 230,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              gap: 20,
            }}
          >
            <ClipLoader size={50} color={colors.primary[500]} loading />
          </div>
        ) : (
          <>
            <Typography
              as="span"
              bold
              size="heading_3"
              textAlign="center"
              style={{
                fontStyle: 'normal',
                lineHeight: '27px',
                marginBottom: '17px',
              }}
            >
              Shifts Overview
            </Typography>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                width: '100%',
              }}
            >
              <NumberItemWithTitle
                title="Open Shifts"
                value={activeCount}
                clickUrl={generatePath(routes.shiftsOverview, { type: 'open' })}
              />
              <NumberItemWithTitle
                title={CONFIRM_CANDIDATE_LABEL}
                value={actionRequiredCount}
                clickUrl={generatePath(routes.shiftsOverview, { type: 'pending' })}
                highlightCount
              />
              <NumberItemWithTitle
                title="Scheduled"
                value={scheduledCount}
                clickUrl={generatePath(routes.shiftsOverview, { type: 'scheduled' })}
              />
            </div>
          </>
        )}
      </div>
    </Link>
  );
};

export default ShiftsWidget;
